<template><section><template>
<h3>气泡框</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-popover effect="fade" :header="true" title="Title" placement="top">
    <div slot="content">
        从前有座山
    </div>
    <n3-button>Popover on top</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="true" title="Title" placement="left">
      <div slot="content">
        山里有座庙
    </div>
    <n3-button>Popover on left</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="true" title="Title" placement="right">
      <div slot="content">
        庙里有个老和尚
    </div>
    <n3-button>Popover on right</n3-button>
  </n3-popover>
  <n3-popover effect="fade" placement="bottom" :header="true" title="Title">
      <div slot="content">
        老和尚说从前有座山
    </div>
    <n3-button>Popover on bottom</n3-button>
  </n3-popover>
  <hr>
  <h4>No title</h4>
  <n3-popover effect="fade" :header="false" title="Title" placement="top">
      <div slot="content">
        山里有座庙
      </div>
      <n3-button>Popover on top</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" title="Title" placement="left">
    <div slot="content">
        庙里有个老和尚
    </div>
    <n3-button>Popover on left</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" title="Title" placement="right">
    <div slot="content">
        老和尚说从前有座山
    </div>
    <n3-button>Popover on right</n3-button>
  </n3-popover>
  <n3-popover effect="fade" :header="false" placement="bottom" title="Title">
    <div slot="content">
        山里有座庙
      </div>
    <n3-button>Popover on bottom</n3-button>
  </n3-popover>
  <hr>
  <h4>Triger</h4>
    <n3-popover effect="scale" title="Title" placement="top" trigger="hover">
        <div slot="content">
          庙里有个老和尚
        </div>
        <n3-button>Mouseenter</n3-button>
    </n3-popover>
    <hr>
  <h4>Focus</h4>
  <n3-popover effect="scale" title="Title" placement="bottom" trigger="focus">
    <div slot="content">
        老和尚很无聊
    </div>
    <n3-input placeholder="Focus"></n3-input>
  </n3-popover>
  <h4>气泡确认</h4>
  <n3-pop-confirm content="确定删除么？" :on-confirm="del(item)">
      <n3-button>删除</n3-button>
  </n3-pop-confirm>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> &gt;</span>
     从前有座山
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on top<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span>&gt;</span>
   <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      山里有座庙
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span>&gt;</span>
   <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      庙里有个老和尚
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> &gt;</span>
   <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span> &gt;</span>
      老和尚说从前有座山
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on bottom<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-comment">&lt;!-- No title  --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>&gt;</span>
   <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      山里有座庙
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on top<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      庙里有个老和尚
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      老和尚说从前有座山
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">:header</span> =<span class="hljs-string">"false"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> &gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      山里有座庙
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>Popover on bottom<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-comment">&lt;!-- Trigger  --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
    庙里有个老和尚
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>Mouseenter<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-comment">&lt;!-- Focus  --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-popover</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Title"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"focus"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"content"</span>&gt;</span>
      老和尚很无聊
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"Focus"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-popover</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 气泡确认  --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-pop-confirm</span>
    <span class="hljs-attr">content</span>=<span class="hljs-string">"确定删除么？"</span>
    <span class="hljs-attr">:on-confirm</span>=<span class="hljs-string">"del(item)"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>删除<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-pop-confirm</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">del(item){
  <span class="hljs-keyword">return</span> <span class="hljs-keyword">new</span> <span class="hljs-built_in">Promise</span>(<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">resolve, reject</span>) </span>{
    setTimeout(<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
      alert(<span class="hljs-string">'删除了'</span> +  item)
      resolve()
    },<span class="hljs-number">500</span>);
  });
}
</code></pre>
<h3>popover参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>trigger</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">click</code> <code v-pre="">focus</code> <code v-pre="">hover</code></td>
<td><code v-pre="">click</code></td>
<td>触发方式</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">scale</code> <code v-pre="">fade</code></td>
<td><code v-pre="">scale</code></td>
<td></td>
</tr>
<tr>
<td>title</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>header</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否显示头部</td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">top</code> <code v-pre="">left</code> <code v-pre="">right</code> <code v-pre="">bottom</code></td>
<td></td>
<td>定位</td>
</tr>
</tbody>
</table>
<h3>popconfirm参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>effect</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">scale</code> <code v-pre="">fade</code></td>
<td><code v-pre="">fade</code></td>
<td></td>
</tr>
<tr>
<td>content</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">top</code> <code v-pre="">left</code> <code v-pre="">right</code> <code v-pre="">bottom</code></td>
<td></td>
<td>定位</td>
</tr>
<tr>
<td>on-confirm</td>
<td><code v-pre="">Function</code></td>
<td></td>
<td>点击确定的回调函数</td>
</tr>
<tr>
<td>ok-text</td>
<td><code v-pre="">String</code></td>
<td>ok</td>
<td>确定按钮的文案</td>
</tr>
<tr>
<td>cancel-text</td>
<td><code v-pre="">String</code></td>
<td>cancel</td>
<td>取消按钮的文案</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      title: 'Title',
      text: 'Lorem ipsum dolor sit amet',
      item: '1'
    }
  },
  methods: {
    del(item){
      return function() {
        return new Promise(function(resolve, reject) {
          setTimeout(function() {
            alert('删除了' + item)
            resolve()
          },500);
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3PopoverDocs.md?2505ec7a